import { useEffect, useState } from 'react';
import { MusicalRight } from '@solo/app-core';
import { ButtonsNavBar, Flex, Text } from '@/app/ui';
import { translate } from '@/app/i18n';
import Colors from '@/app/styles/Colors';

// type EaringsByCountry = {
//   [key: string]: number;
// };

type TopEarningsByCountry = {
  earnings: number;
  country: string;
};

const MOCK_DISTRIBUTION_EARNINGS = 9.5;
const MOCK_PUBLISHING_EARNINGS = 6;

const TopRevenueCountry = () => {
  const [activeTab, setActiveTab] = useState<string>(translate('EARNINGS.ALL'));
  const [, setEarningType] = useState<MusicalRight | undefined>();
  // const { consumptionReportsBloc, territoryBloc, authBloc } = useCradle<Cradle>();
  // const authState = useBlocState(authBloc);

  const [earningsByCountry, setEarningsByCountry] = useState<TopEarningsByCountry[]>([]);
  // const [territories, setTerritories] = useState<Territory[]>([]);

  // useEffect(() => {
  //   async function loadTerritories() {
  //     const t = await territoryBloc.getTerritories(TerritoryType.COUNTRY);
  //     setTerritories(t);
  //   }
  //   loadTerritories();
  // }, []);

  useEffect(() => {
    if (activeTab === translate('EARNINGS.ALL')) {
      setEarningsByCountry([
        { earnings: MOCK_DISTRIBUTION_EARNINGS + MOCK_PUBLISHING_EARNINGS, country: 'Spain' },
      ]);
    } else if (activeTab === translate('DIGITAL_DISTRIBUTION.DIGITAL_DISTRIBUTION')) {
      setEarningsByCountry([{ earnings: MOCK_DISTRIBUTION_EARNINGS, country: 'Spain' }]);
    } else if (activeTab === translate('EARNINGS.PUBLISHING')) {
      setEarningsByCountry([{ earnings: MOCK_PUBLISHING_EARNINGS, country: 'Spain' }]);
    }
  }, [activeTab]);

  function changeTab(tab: string) {
    switch (tab) {
      case translate('EARNINGS.ALL'):
        setEarningType(undefined);
        break;
      case translate('DIGITAL_DISTRIBUTION.DIGITAL_DISTRIBUTION'):
        setEarningType(MusicalRight.DISTRIBUTION);
        break;
      default:
        setEarningType(MusicalRight.PUBLISHING);
        break;
    }
    setActiveTab(tab);
  }

  return (
    <Flex.Container gap="1rem" flexDirection="column">
      <ButtonsNavBar
        defaultTab={translate('EARNINGS.ALL')}
        tabs={[
          translate('EARNINGS.ALL'),
          translate('DIGITAL_DISTRIBUTION.DIGITAL_DISTRIBUTION'),
          translate('EARNINGS.PUBLISHING'),
        ]}
        onSelectTab={(tab) => changeTab(tab)}
      />
      <Flex.Container flexDirection="column">
        {earningsByCountry.map((earning, index) => (
          <Flex.Container
            key={earning.country}
            gap="1rem"
            style={{ borderTop: index !== 0 ? `1px solid ${Colors.borderInput}` : '' }}
            padding="1rem 0"
          >
            <Flex.Container gap="1rem">
              <Text.LabelMedium style={{ paddingTop: '3px' }}>{earning.country}</Text.LabelMedium>
            </Flex.Container>
            <Flex.Container
              style={{ width: '50%', marginLeft: 'auto' }}
              alignItems="flex-end"
              flexDirection="column"
            >
              <Text.Span style={{ textTransform: 'capitalize' }}>{earning.earnings}€</Text.Span>
            </Flex.Container>
          </Flex.Container>
        ))}
      </Flex.Container>
    </Flex.Container>
  );
};

export default TopRevenueCountry;
